import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Announcement } from '../models/announcement.model';
import { AlertService } from '../../shared/services/alert.service';

@Injectable({
  providedIn: 'root'
})
export class ShareService {
  private alertService = inject(AlertService);
  private platformId = inject(PLATFORM_ID);

  copyLink(): void {
    if (isPlatformBrowser(this.platformId)) {
      navigator.clipboard.writeText(window.location.href).then(() => {
        this.alertService.success('Link kopyalandı');
      });
    }
  }

  getShareLinks(listing: Announcement) {
    let url = '';
    if (isPlatformBrowser(this.platformId)) {
      url = encodeURIComponent(window.location.href);
    }
    const text = encodeURIComponent(`${listing.price} ₼ - ${listing.rooms} otaqlı - ${listing.region}`);

    return {
      whatsapp: `https://wa.me/?text=${text}%20${url}`,
      telegram: `https://t.me/share/url?url=${url}&text=${text}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`
    };
  }
}
